// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"v1-z","displaySixCardTiles":"w1-z"};